// 导入请求数据的 request 模块
import request from '@/utils/request'

// 根据省份、专业、年级查询学校信息
export const SelectSchool = (province, major, grade, currentPage, pageSize) => {
  return request.get('/school/select', {
    params: {
      province: province,
      major: major,
      grade: grade,
      currentPage: currentPage,
      pageSize: pageSize
    }
  })
}

// 根据学校名称查询学校信息
export const getSchoolName = (name, currentPage, pageSize) => {
  return request.get('/school/select/name', {
    params: {
      name: name,
      currentPage: currentPage,
      pageSize: pageSize
    }
  })
}
